import React from "react";
import { useNavigate } from "react-router-dom";
import "../Login/Login.css";
import logo from "../../assets/dr-is-in.png";

export default function ContactUsPortal() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Doctor Is In Logo" className="login-logo" />

        <h2 className="login-title">Contact Us</h2>
        <div className="login-tagline">AI Wellness Advisor with a human touch.</div>

        <div className="login-actions">
          <button type="button" className="login-btn" onClick={() => navigate("/contact-us/general")}>
            General Information
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/contact-us/issues")}>
            App Issues
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/contact-us/survey")}>
            Survey
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/login")}>
            ← Back to Login
          </button>
        </div>

        <div className="login-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
}